export default __webpack_public_path__ + "static/media/logo-white-02.7b9a3380.png";